// extracted by mini-css-extract-plugin
export default {"flagWrapper":"QGTarcUznc_vUE4a8IBh","icon":"SSiaiuF38zzgCFFbidca","default":"sbuTbptG1ZaNLSHGwlog","small":"xe5pCcoYVINCFW85K6en","iconShadow":"tIoutAWkB1vNY2T1K3tr"};